<template>
  <div class="ont-page">
    <div class="container minheight">
      <h1>About Us</h1> 
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  data() {
    return {
    };
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/main.scss';
@import '../assets/scss/landing.scss';
</style>
